import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Chip, CircularProgress, Tooltip } from "@mui/material";
import { useSnackbar } from "notistack";
import { makeStyles } from "@mui/styles";
import {
  import_template_data_api,
  link_listing_api_v2,
} from "src/DAL/WebsitePages/WebsitePages";
import { websiteUrl } from "src/config/config";
import CustomMUITable from "src/components/GeneralComponents/CustomMUITable/CustomMUITable";
import CustomConfirmation from "src/components/menuIcons/CustomConfirmation";
import CopyToClipboard from "react-copy-to-clipboard";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

export default function LinkList({ type }) {
  const navigate = useNavigate();
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [templateData, setTemplateData] = useState([]);
  const [selectedObject, setSelectedObject] = useState({});
  const [openModel, setOpenModel] = useState(false);
  const [isAccess, setIsAccess] = useState();
  const [affiliateUrl, setAffiliateUrl] = useState("");
  const [pageCount, setPageCount] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalCount, setTotalCount] = useState("");
  const [searchText, setSearchText] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [page, setPage] = useState(0);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    if (newPage <= 0) {
      setPageCount(1);
    } else {
      setPageCount(newPage + 1);
    }
  };
  const handleChangePages = (event, newPage) => {
    if (newPage <= 0) {
      setPage(0);
      setPageCount(1);
    } else {
      setPage(newPage - 1);
      setPageCount(newPage);
    }
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPageCount(1);
    setPage(0);
  };
  const searchFunction = () => {
    setPage(0);
    setPageCount(1);
    localStorage.setItem(type + "_link_search", searchText);

    getTemplatePagesListing();
  };

  const getTemplatePagesListing = async (search) => {
    setIsLoading(true);
    let PostData = {
      search: searchText ? searchText?.trim() : search?.trim(),
      type_of_page: type,
    };
    const result = await link_listing_api_v2(PostData, page, rowsPerPage);
    if (result.code === 200) {
      let teamType = result.team_type;
      setAffiliateUrl(result?.affiliate_object?.affiliate_url_name);
      let result_array = [];
      setIsAccess(result.is_access);

      result.sale_pages?.map((template) => {
        result_array.push({
          ...template,
          preview_link_data: {
            to:
              websiteUrl +
              template.sale_page_title_slug +
              "/" +
              result?.affiliate_object?.affiliate_url_name,
            target: "_blank",
            show_text: "Preview",
            className: "anchor-style",
          },
          MENU_OPTIONS: menuHandling(template, teamType),
        });
      });
      setTotalPages(result.total_pages);
      setTotalCount(result.page_count);
      setTemplateData(result_array);
      setIsLoading(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };
  const handleCopiedUrl = () => {
    enqueueSnackbar("Preview Url copied to clipboard", { variant: "success" });
  };

  const handleCopiedAppointment = () => {
    enqueueSnackbar("Appointment Url copied to clipboard", {
      variant: "success",
    });
  };

  const TABLE_HEAD = [
    { id: "number", label: "#", alignRight: false, type: "number" },
    { id: "sale_page_title", label: "Page Title", alignRight: false },
    {
      id: "preview_link_data",
      label: "URL",
      type: "link",
      alignRight: false,
    },
    {
      id: "action",
      label: "Action",
      alignRight: false,
      MENU_OPTIONS: "MENU_OPTIONS",
      type: "action",
    },
  ];

  TABLE_HEAD.splice(2, 0, {
    id: "sale_page_title1",
    label: "Copy URL",
    alignRight: false,
    renderData: (row) => {
      return (
        <>
          {row.type_of_page == "book_a_call_page" ? (
            <CopyToClipboard
              text={
                websiteUrl +
                row.sale_page_title_slug +
                "/appointment/" +
                affiliateUrl
              }
              onCopy={() => handleCopiedAppointment(true)}
            >
              <Tooltip title="Click to copy Appointment URL">
                <Chip
                  label="Copy Appointment URL"
                  color="primary"
                  variant="outlined"
                  className="mt-2"
                />
              </Tooltip>
            </CopyToClipboard>
          ) : (
            <CopyToClipboard
              text={websiteUrl + row.sale_page_title_slug + "/" + affiliateUrl}
              onCopy={() => handleCopiedUrl(true)}
            >
              <Tooltip title="Click to copy Preview URL">
                <Chip
                  label="Copy Main URL"
                  color="primary"
                  variant="outlined"
                />
              </Tooltip>
            </CopyToClipboard>
          )}
        </>
      );
    },
  });

  const handleEdit = (value) => {
    delete value.MENU_OPTIONS;
    navigate(`/website-pages/edit-page/${value.sale_page_title_slug}`, {
      state: value,
    });
  };
  const handleSetCommission = (value) => {
    delete value.MENU_OPTIONS;
    navigate(`/website-links/set-commission/${value._id}`, {
      state: value,
    });
  };
  const handleManageSubteamAccess = (value) => {
    delete value.MENU_OPTIONS;
    navigate(`/website-links/manage-subteam-access/${value._id}`, {
      state: value,
    });
  };

  const handleUpdatePageContent = (value) => {
    delete value.MENU_OPTIONS;
    navigate(
      `/website-pages/update-page-content/${value.sale_page_title_slug}`,
      {
        state: value,
      }
    );
  };

  const handleRedirect = (module, value) => {
    switch (module.module_actual_name) {
      case "testimonial":
        navigate(`/website-pages/${value._id}/testimonials`, {
          state: value,
        });
        break;
      case "payment_plans":
        navigate(`/website-pages/${value._id}/payment-plans`, {
          state: value,
        });
        break;
      case "website_programmes":
        navigate(`/website-pages/${value._id}/website-programmes`, {
          state: value,
        });
        break;
      case "buisness_strategy":
        navigate(`/website-pages/${value._id}/business-strategy`, {
          state: value,
        });
        break;
      case "website_faq":
        navigate(`/website-pages/${value._id}/website-faq`, {
          state: value,
        });
        break;
      case "wheel_of_life":
        navigate(`/website-pages/${value._id}/questions`, {
          state: value,
        });
        break;
      case "success_schedule":
        navigate(`/website-pages/${value._id}/success-schedule`, {
          state: value,
        });
        break;
      default:
      // code block
    }
  };

  const handleAgreeImportData = (value) => {
    setSelectedObject(value);
    setOpenModel(true);
  };

  const handleDelete = async () => {
    setOpenModel(false);
    setIsLoading(true);
    const dataObject = {
      sale_page_id: selectedObject._id,
    };

    const result = await import_template_data_api(dataObject);
    if (result.code === 200) {
      getTemplatePagesListing();
      enqueueSnackbar(result.message, { variant: "success" });
    } else {
      setIsLoading(true);
      enqueueSnackbar(result.message, { variant: "error" });
    }
  };
  const handleCopyURL = async (e) => {
    await navigator.clipboard.writeText(websiteUrl + e.sale_page_title_slug);
    enqueueSnackbar("Preview Url copied to clipboard", {
      variant: "success",
    });
  };
  const handleCopyAppointmentURL = async (e) => {
    await navigator.clipboard.writeText(
      websiteUrl + e.sale_page_title_slug + "/appointment"
    );
    enqueueSnackbar("Appointment URL Copied to clipboard", {
      variant: "success",
    });
  };

  const menuHandling = (value, teamType) => {
    const MENU_OPTIONS = [
      {
        label: "Copy main URL",
        icon: "eva:eye-fill",
        handleClick: handleCopyURL,
      },
    ];

    if (value.type_of_page == "book_a_call_page") {
      MENU_OPTIONS.push({
        label: "Copy Appointment URL",
        icon: "eva:eye-fill",
        handleClick: handleCopyAppointmentURL,
      });
    }
    if (teamType !== "sub_team" && value.plan_count > 0) {
      MENU_OPTIONS.push({
        label: "Set Commisssion",
        icon: "akar-icons:edit",
        handleClick: handleSetCommission,
      });
    }
    if (teamType !== "sub_team") {
      MENU_OPTIONS.push({
        label: "Manage Sub Team Access",
        icon: "akar-icons:edit",
        handleClick: handleManageSubteamAccess,
      });
    }

    return MENU_OPTIONS;
  };

  useEffect(() => {
    const search = localStorage.getItem(type + "_link_search");
    if (search) {
      setSearchText(search);
    }
    getTemplatePagesListing(search);
  }, [page, rowsPerPage]);

  if (isLoading == true) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  return (
    <>
      <CustomConfirmation
        open={openModel}
        setOpen={setOpenModel}
        title_html={
          <div className="confirmation-popup-title">
            <h2>Are you sure you want to import template data?</h2>
            <p>
              Importing template data will update page content and copy other
              modules data.
            </p>
          </div>
        }
        handleAgree={handleDelete}
      />
      <div className="">
        <div className="mt-3">
          <CustomMUITable
            TABLE_HEAD={TABLE_HEAD}
            data={templateData}
            className="card-with-background"
            custom_pagination={{
              total_count: totalCount,
              rows_per_page: rowsPerPage,
              page: page,
              handleChangePage: handleChangePage,
              onRowsPerPageChange: handleChangeRowsPerPage,
            }}
            custom_search={{
              searchText: searchText,
              setSearchText: setSearchText,
              handleSubmit: searchFunction,
            }}
            pagePagination={true}
            pageCount={pageCount}
            totalPages={totalPages}
            handleChangePages={handleChangePages}
          />
        </div>
      </div>
    </>
  );
}
